/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * desakita API — permukaan publik
 * Dokumen TURUNAN — JANGAN diedit. Dihasilkan scripts/gen-public-spec.ts dari dist/openapi.bundled.yaml, memuat HANYA operasi ber-`security: []`. Untuk mengubah isinya, ubah kontraknya (openapi/features/*.yaml) lalu daftarkan operationId-nya di openapi/_shared/public-operations.yaml.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BukuTamuPejabatResponse,
  FailureResponse,
  PublicBukuTamuCreateRequestItem,
  PublicBukuTamuResponse,
  SuccessEnvelope,
  ValidationFailureResponse
} from '../../model';

import { publicFetch } from '../../../mutator/publicFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPostPublicBukuTamuUrl = () => {




  return `/public/buku-tamu`
}

export const postPublicBukuTamu = async (publicBukuTamuCreateRequestItem: PublicBukuTamuCreateRequestItem[], options?: RequestInit): Promise<SuccessEnvelope & PublicBukuTamuResponse> => {

  return publicFetch<SuccessEnvelope & PublicBukuTamuResponse>(getPostPublicBukuTamuUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicBukuTamuCreateRequestItem)
  }
);}





export const getPostPublicBukuTamuMutationOptions = <TError = ValidationFailureResponse | FailureResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicBukuTamu>>, TError,{data: PublicBukuTamuCreateRequestItem[]}, TContext>, request?: SecondParameter<typeof publicFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicBukuTamu>>, TError,{data: PublicBukuTamuCreateRequestItem[]}, TContext> => {

const mutationKey = ['postPublicBukuTamu'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicBukuTamu>>, {data: PublicBukuTamuCreateRequestItem[]}> = (props) => {
          const {data} = props ?? {};

          return  postPublicBukuTamu(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPublicBukuTamuMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicBukuTamu>>>
    export type PostPublicBukuTamuMutationBody = PublicBukuTamuCreateRequestItem[]
    export type PostPublicBukuTamuMutationError = ValidationFailureResponse | FailureResponse

    export const usePostPublicBukuTamu = <TError = ValidationFailureResponse | FailureResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicBukuTamu>>, TError,{data: PublicBukuTamuCreateRequestItem[]}, TContext>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicBukuTamu>>,
        TError,
        {data: PublicBukuTamuCreateRequestItem[]},
        TContext
      > => {
      return useMutation(getPostPublicBukuTamuMutationOptions(options), queryClient);
    }
    export const getGetPublicBukuTamuPejabatUrl = () => {




  return `/public/buku-tamu/pejabat`
}

export const getPublicBukuTamuPejabat = async ( options?: RequestInit): Promise<SuccessEnvelope & BukuTamuPejabatResponse> => {

  return publicFetch<SuccessEnvelope & BukuTamuPejabatResponse>(getGetPublicBukuTamuPejabatUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicBukuTamuPejabatQueryKey = () => {
    return [
    `/public/buku-tamu/pejabat`
    ] as const;
    }


export const getGetPublicBukuTamuPejabatQueryOptions = <TData = Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicBukuTamuPejabatQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>> = ({ signal }) => getPublicBukuTamuPejabat({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicBukuTamuPejabatQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>>
export type GetPublicBukuTamuPejabatQueryError = FailureResponse


export function useGetPublicBukuTamuPejabat<TData = Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>,
          TError,
          Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicBukuTamuPejabat<TData = Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>,
          TError,
          Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicBukuTamuPejabat<TData = Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicBukuTamuPejabat<TData = Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicBukuTamuPejabat>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicBukuTamuPejabatQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






